module.exports = __webpack_public_path__ + "img/54.da241508.png";